import script from "./PreciosAltos.vue?vue&type=script&setup=true&lang=js"
export * from "./PreciosAltos.vue?vue&type=script&setup=true&lang=js"

import "./PreciosAltos.vue?vue&type=style&index=0&id=53bd057c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bd057c"]])

export default __exports__